import { useMemo } from 'react'
import { useCheckFanduelRSN } from './useCheckFanduelRSN'
import { PlanTypes } from 'src/constants/standaloneData'
import { useIsRSNAvailable } from './useIsRSNAvailable'
import { useFormatFanduelData } from './useFormatFanduelData'
import { latinoPlanData } from 'src/constants/planData/latinoPlanData'
import { ratePlanCodes } from 'src/constants'

export const useIsLatinoBundleAvailable = ({ lang = 'en' }) => {
  const { isAvailable: isFanduelAvailable, rsnData: fanduelData } = useCheckFanduelRSN({
    sportType: 'nba',
  })

  // Only check MASN if FanDuel is not available
  const { isAvailable: isMasnAvailable } = useIsRSNAvailable(
    !isFanduelAvailable ? PlanTypes.MASN_PLUS : null
  )

  const fdPlanData = useFormatFanduelData(
    lang === 'en'
      ? latinoPlanData.latino_plus_equipos_locales_en_monthly
      : latinoPlanData.latino_plus_equipos_locales_es_monthly,
    fanduelData,
    false
  )
  // Use useMemo to derive the available data based on priority
  return useMemo(() => {
    if (isFanduelAvailable) {
      return {
        ...fdPlanData,
        offerCode:
          fanduelData.rsn.length > 1
            ? ratePlanCodes.latino_baseball_2rsn
            : ratePlanCodes.latino_baseball_1rsn,
      }
    }
    if (isMasnAvailable) {
      return lang === 'en'
        ? latinoPlanData.latino_masn_en_monthly
        : latinoPlanData.latino_masn_es_monthly
    }
    return null
  }, [
    isFanduelAvailable,
    isMasnAvailable,
    {
      ...fdPlanData,
    },
    lang,
  ])
}
